import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PromotionCartState } from "@WhiteCap/Store/Data/PromotionState";
import { Draft } from "immer";



const initialState: PromotionCartState = {
    isLoading: false,
};

const reducer = {
    "Custom/PromotionCart/BeginLoadProducts": (draft: Draft<PromotionCartState>) => {
        draft.isLoading = true;
    },
    
    "Custom/PromotionCart/BeginEndedProducts": (draft: Draft<PromotionCartState>) => {
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
